import { IntegrationStatus } from "types/enums.ts";
import { z } from "zod";

export const schema = z.object({
    name: z
        .string({ required_error: "forms.general-validation.name_required" })
        .min(1, "forms.general-validation.name_required"),
    form_structure_id: z
        .string({ required_error: "forms.general-validation.form_structure_required" })
        .min(1, "forms.general-validation.form_structure_required"),
    owner_id: z
        .string({ required_error: "forms.general-validation.advertiser_required" })
        .min(1, "forms.general-validation.advertiser_required"),
    custom_flow: z.boolean(),
    debug_mode: z.boolean(),
    use_new_connection_creator: z.boolean(),
    status: z.nativeEnum(IntegrationStatus, {
        errorMap: () => ({ message: "forms.general-validation.invalid_status" }),
    }),
    notes: z.string(),
    country_id: z.number().nullable().optional(),
    category: z.string().nullable().optional(),
});

export type AddApiIntegrationFormData = z.infer<typeof schema>;
